import { Injectable, PLATFORM_ID, TransferState, inject } from "@angular/core";
import { isPlatformServer } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class TransferStateService {
  transferState = inject(TransferState);
  http = inject(HttpClient);
  platformId = inject(PLATFORM_ID);

  apiUrl = environment.apiUrl;

  constructor() {
    const platformId = this.platformId;

    if (isPlatformServer(platformId)) {
      // this.apiUrl = 'http://api:80';
    }
  }
}
